import MigrationItemViewDTO from '@src/adapters/dto/migration/MigrationItemViewDTO';
import useApi, { ApiOptions } from '../base/useApi';

interface Params {
  id: string;
  approved: boolean;
}

interface Result {
  item: MigrationItemViewDTO;
}

const options: ApiOptions = {
  method: 'post',
  urlPath: '/migration/item_approval/',
  baseUrl: process.env.REACT_APP_API_URL!,
  lazy: false,
};

export const useSaveMigrationItemApprovalLazy = (params?: Params) => {
  options.lazy = true;
  return useApi<Params, Result>(options, params);
};

export default useSaveMigrationItemApprovalLazy;
